export enum GlobalSearchResultType {
  InvoiceSearchResults = 'invoiceSearchResults',
  ShipmentSearchResults = 'shipmentSearchResults',
  DisputeSearchResults = 'disputeSearchResults',
  ClaimSearchResults = 'claimSearchResults',
}
